import { HttpClient, HttpHeaders, HttpErrorResponse, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Subject, timer, throwError } from 'rxjs';
import { catchError, mergeMap, observeOn, retryWhen } from 'rxjs/operators';
import { FikoYTEnvIstemci } from '../../Environment/environment';
import { CihazKimlikService } from '../../fikoyt.cihaz-kimlik.service';
import IstekSonuc, { FikoHata, FikoHatalar, IstekIlerleme, IstekOlayTuru } from './fikoyt-istek.interface';
import { ChangeDetectorRef, inject, Injector, runInInjectionContext, signal, WritableSignal } from '@angular/core';

type FikoYTVoidCallback<T> = (_: { self: FikoYTIstekKok<T> }) => void;
// type FikoYTCallback<T> = (req: FikoYTIstekKok, res: FikoYTRequestResponse<T>) => void;
type FikoYTHataCallback = (_: { self: FikoYTIstekKok, hatalar: FikoHatalar }) => void;
type FikoYTIlerlemeCallback = (_: { self: FikoYTIstekKok, ilerleme: IstekIlerleme | any }) => void;
type FikoYTCevapCallback<T> = (_: { self: FikoYTIstekKok, sonuc: any }) => void;
type FikoYTOnceCevapCallback<T> = (_: { self: FikoYTIstekKok, sonuc: any }) => T | any;
type FikoYTMesgulDegistiCallback<T> = (_: { self: FikoYTIstekKok, mesgul: any }) => T | any;

class FikoYTQueueItem<T> {
    constructor(public engine: FikoYTIstekKok<T>, public oncelik: number) { }
}

// export class FikoYTRequestResponse<T> {
//     result?: T;
//     type: 'NETWORK' | 'CACHED' = 'NETWORK';
//     endTime: Date = new Date();
//     progress?: number;  // progress yüzde (0-100)
// }

// export class FikoYTError {
//     constructor(public title: string, public message: string) { }
// }

// export class FikoYTErrors {
//     list: FikoYTError[] = [];
//     get messages(): string[] {
//         return this.list.map(e => `${e.title}: ${e.message}`);
//     }
// }

interface IOptionsKok {
    // injector?: Injector,
    metod?: "POST" | "GET" | "PUT" | "DELETE" | "PATCH" | "OPTIONS" | "HEAD" | "TRACE" | "CONNECT",
    komut?: string,
    onEkOlsun?: boolean,
    parametreler?: any,
    tekrarSayisi?: number,
    tekrarBekleme?: number,
    oncelik?: number,
    depoModu?: boolean,
    gecikmeliCevapSuresi?: number,
    gecikmeliCevap?: boolean,
    otoMesgul?: boolean,
    [key: string]: any
}

export class FikoYTIstekKok<T = any> {
    // Statik HttpClient: dışardan mutlaka set edilmeli
    static httpClient: HttpClient;
    static Cihaz: CihazKimlikService;
    // public readonly CD: ChangeDetectorRef;

    private static kuyruk: FikoYTQueueItem<any>[] = [];
    private static aktifOlanlarinSayisi = 0;
    private static duraklatildi = false;
    private static enFazlaEszamanliIstek = 10;


    // private static ramDeposu = new Map<string, any>();
    // private static lokalDepoIsmiOnEki = 'fiko-cache-';

    metod: "POST" | "GET" | "PUT" | "DELETE" | "PATCH" | "OPTIONS" | "HEAD" | "TRACE" | "CONNECT";
    komut: string;
    onEkOlsun: boolean;
    parametreler: any;
    tekrarSayisi: number;
    tekrarBekleme: number;
    oncelik: number;
    // depoModu: boolean;

    cevap: IstekSonuc<T> = {
        turu: IstekOlayTuru.Beklemede,
        durum: { hata: false, hatalar: [], mesgul: false, },
        istekIlerleme: undefined,
        cevapIlerleme: undefined,
        sonuc: undefined,
        istek: undefined
    };

    private cancelSubject = new Subject<void>();
    private isCancelled = false;
    mesgul = false;

    private onBaslatildiListe: FikoYTVoidCallback<T>[] = [];
    private onIstekIlerlemeListe: FikoYTIlerlemeCallback[] = [];
    private onCevapIlerlemeListe: FikoYTIlerlemeCallback[] = [];
    private onCevapListe: FikoYTCevapCallback<T>[] = [];
    private onOnceCevapListe: FikoYTOnceCevapCallback<T>[] = [];
    private onTamamlandiListe: FikoYTVoidCallback<T>[] = [];
    private onHataListe: FikoYTHataCallback[] = [];
    private onceCalistirListe: FikoYTVoidCallback<T>[] = [];
    private onMesgulDegistiListe: FikoYTMesgulDegistiCallback<T>[] = [];

    gecikmeliCevapSuresi?: number = 1000;
    gecikmeliCevap?: boolean = false;
    otoMesgul?: boolean = true;

    constructor(options?: IOptionsKok) {
        // this.CD = inject(ChangeDetectorRef);
        this.metod = options?.metod ?? 'POST';
        this.komut = options?.komut ?? '';
        this.onEkOlsun = options?.onEkOlsun ?? true;
        this.parametreler = options?.parametreler ?? {};
        this.tekrarSayisi = options?.tekrarSayisi ?? 0;
        this.tekrarBekleme = options?.tekrarBekleme ?? 300;
        this.oncelik = options?.oncelik ?? 0;
        this.gecikmeliCevapSuresi = options?.gecikmeliCevapSuresi ?? 1000;
        this.gecikmeliCevap = options?.gecikmeliCevap ?? false;
        this.otoMesgul = options?.otoMesgul ?? true;
        // this.depoModu = options?.depoModu ?? false;
    }

    /**
     * Genel static istek metodu - Constructor parametreleri ve callback'lerle
     * @param options Constructor seçenekleri + callback'ler
     */
    static request<T = any>(
        options: IOptionsKok & {
            onCevap?: FikoYTCevapCallback<T>;
            onHata?: FikoYTHataCallback;
            onIstekIlerleme?: FikoYTIlerlemeCallback;
            onCevapIlerleme?: FikoYTIlerlemeCallback;
            onTamamlandi?: FikoYTVoidCallback<T>;
            onBaslatildi?: FikoYTVoidCallback<T>;
            onOnceCevap?: FikoYTOnceCevapCallback<T>;
            onMesgulDegisti?: FikoYTMesgulDegistiCallback<T>;
            oncesindeCalistir?: FikoYTVoidCallback<T>;
        }
    ): FikoYTIstekKok<T> {
        const { 
            onCevap, 
            onHata, 
            onIstekIlerleme, 
            onCevapIlerleme,
            onTamamlandi, 
            onBaslatildi,
            onOnceCevap,
            onMesgulDegisti,
            oncesindeCalistir,
            ...constructorOptions 
        } = options;
        
        const instance = new FikoYTIstekKok<T>(constructorOptions);
        
        // Callback'leri ekle
        if (onCevap) instance.onCevap(onCevap);
        if (onHata) instance.onHata(onHata);
        if (onIstekIlerleme) instance.onIstekIlerleme(onIstekIlerleme);
        if (onCevapIlerleme) instance.onCevapIlerleme(onCevapIlerleme);
        if (onTamamlandi) instance.onTamamlandi(onTamamlandi);
        if (onBaslatildi) instance.onBaslatildi(onBaslatildi);
        if (onOnceCevap) instance.onOnceCevap(onOnceCevap);
        if (onMesgulDegisti) instance.onMesgulDegisti(onMesgulDegisti);
        if (oncesindeCalistir) instance.oncesindeCalistir(oncesindeCalistir);
        
        return instance;
    }

    static configure(options: { maxConcurrentRequests?: number }) {
        if (options.maxConcurrentRequests !== undefined) {
            FikoYTIstekKok.enFazlaEszamanliIstek = options.maxConcurrentRequests;
        }
    }

    static pause() {
        this.duraklatildi = true;
    }

    static resume() {
        this.duraklatildi = false;
        this.tryProcessQueue();
    }

    // static clearCache() {
    //     this.ramDeposu.clear();
    //     for (const key of Object.keys(localStorage)) {
    //         if (key.startsWith(this.lokalDepoIsmiOnEki)) {
    //             localStorage.removeItem(key);
    //         }
    //     }
    // }

    onBaslatildi(fn: FikoYTVoidCallback<T>) { this.onBaslatildiListe.push(fn); return this; }
    onIstekIlerleme(fn: FikoYTIlerlemeCallback) { this.onIstekIlerlemeListe.push(fn); return this; }
    onCevapIlerleme(fn: FikoYTIlerlemeCallback) { this.onCevapIlerlemeListe.push(fn); return this; }
    onOnceCevap(fn: FikoYTOnceCevapCallback<T>) { this.onOnceCevapListe.push(fn); return this; }
    onCevap(fn: FikoYTCevapCallback<T>) { this.onCevapListe.push(fn); return this; }
    onTamamlandi(fn: FikoYTVoidCallback<T>) { this.onTamamlandiListe.push(fn); return this; }
    onHata(fn: FikoYTHataCallback) { this.onHataListe.push(fn); return this; }
    oncesindeCalistir(fn: FikoYTVoidCallback<T>) { this.onceCalistirListe.push(fn); return this; }
    onMesgulDegisti(fn: FikoYTMesgulDegistiCallback<T>) { this.onMesgulDegistiListe.push(fn); return this; }

    iptal() {
        this.isCancelled = true;
        this.cancelSubject.next();
    }

    /**
     * İstek başlatma.
     * @param kuyrugaEkle true ise kuyrukta bekle, false ise hemen başlat
     */
    iste(kuyrugaEkle: boolean = false): FikoYTIstekKok<T> {
        if (this.mesgul) return this;

        if (kuyrugaEkle) {
            FikoYTIstekKok.kuyruk.push(new FikoYTQueueItem(this, this.oncelik));
            FikoYTIstekKok.kuyruk.sort((a, b) => b.oncelik - a.oncelik);
            FikoYTIstekKok.tryProcessQueue();
        } else {
            this.execute(() => { /* tamamlandı */ });
        }
        return this;
    }

    private static tryProcessQueue() {
        if (this.duraklatildi) return;
        if (this.aktifOlanlarinSayisi >= this.enFazlaEszamanliIstek) return;

        const nextItem = this.kuyruk.shift();
        if (!nextItem) return;

        this.aktifOlanlarinSayisi++;
        const engine = nextItem.engine;
        engine.execute(() => {
            this.aktifOlanlarinSayisi--;
            this.tryProcessQueue();

            // 🔁 Eğer isteSync çağrıldıysa resolve et
            if (engine._calistirResolve) {
                engine._calistirResolve(engine);
                engine._calistirResolve = undefined;
            }
        });
    }
    // private getCacheKey(): string {
    //     return `${this.metod}:${this.komut}:${JSON.stringify(this.parametreler)}`;
    // }

    private async execute(onComplete: () => void) {
        if (this.isCancelled) return;

        // setTimeout(() => {
            if (this.otoMesgul == true)
                this.mesgul = true;
            this.onMesgulDegistiListe.forEach(fn => fn({ self: this, mesgul: this.mesgul }));
            // this.CD.detectChanges();
        // }, 0);

        this.onBaslatildiListe.forEach(fn => fn({ self: this }));
        this.onceCalistirListe.forEach(fn => fn({ self: this }));

        // const cacheKey = this.getCacheKey();

        // if (this.depoModu) {
        //     const memoryHit = FikoYTIstekKok.ramDeposu.get(cacheKey);
        //     const localHit = localStorage.getItem(FikoYTIstekKok.lokalDepoIsmiOnEki + cacheKey);
        //     const parsedLocal = localHit ? JSON.parse(localHit) : null;

        //     const result = memoryHit ?? parsedLocal;
        //     if (result) {
        //         const res = new FikoYTRequestResponse<T>();
        //         res.result = result;
        //         res.type = 'CACHED';
        //         this.onResult.forEach(fn => fn(this, res));
        //         this.onDone.forEach(fn => fn(this));
        //         this.isBusy$.next(false);
        //         onComplete();
        //         return;
        //     }
        // }

        if (!FikoYTIstekKok.httpClient) {
            throw new Error('HttpClient statik olarak set edilmemiş! Kullanımdan önce mutlaka FikoYTIstekMakinesi.httpClient = ... atanmalı.');
        }
        if (!FikoYTIstekKok.Cihaz) {
            throw new Error('Cihaz Servisi statik olarak set edilmemiş! Kullanımdan önce mutlaka FikoYTIstekMakinesi.Cihaz = ... atanmalı.');
        }
        const headers = new HttpHeaders(
            {
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Credentials": "true",
                "mode": 'no-cors',
                "uygulama": FikoYTEnvIstemci.uygulamaIsmi,
                "cihaz_kimlik": FikoYTIstekKok.Cihaz.kimlik,
                "cihaz_tipi": FikoYTIstekKok.Cihaz.bilgiler?.deviceType ?? "Web",
                // @ts-ignore
                // "cihaz_bilgi": this.Cihaz.bilgiler.toJson(),
            });

        let url: string;
        if (this.onEkOlsun) {
            url = FikoYTEnvIstemci.adres.url + ":" + FikoYTEnvIstemci.adres.fapiPort + '/fapiv1/' + `${FikoYTEnvIstemci.uygulamaIsmi}.` + this.komut;
        } else {
            url = FikoYTEnvIstemci.adres.url + ":" + FikoYTEnvIstemci.adres.fapiPort + this.komut;
        }

        const req = new HttpRequest(this.metod, url, this.parametreler, {
            /** BİLGİ: İlerleme Durumu Hakkında Rapor Almak İçin */
            reportProgress: true,
            /** BİLGİ: Response Headerleri */
            headers: headers,
            /** BİLGİ: 
             * Session Ve Cookie Yani Request Bilgileri İle İletim Yapmak İçin 
             * Giriş Kontrolü Ve Aktif Kullanıcı İçin Gerekli (Flask.current_user)
             */
            withCredentials: true
        });


        this.cevap = {
            turu: IstekOlayTuru.Beklemede,
            cevapIlerleme: { tipi: "DOWNLOAD", toplam: 0, durum: 0, yuzde: 0 },
            istekIlerleme: { tipi: "UPLOAD", toplam: 0, durum: 0, yuzde: 0 },
            durum: { hata: false, hatalar: [], baslamaZamani: new Date(), bitisZamani: null, mesgul: true, tekrar: 0 },
            istek: { ismi: this.metod, parametreler: this.parametreler, },
            sonuc: undefined,

            ...this.cevap
        };

        // this.cevap.update((_val: IstekSonuc<any>) => {

        //     return _val;
        // })
        // post metodu olduğundan ve progress istendiğinden observe: 'events' kullanalım
        return await FikoYTIstekKok.httpClient.request(req).pipe(
            retryWhen(errors =>
                errors.pipe(
                    mergeMap((error, index) => {
                        return index < this.tekrarSayisi ? timer(this.tekrarBekleme) : throwError(() => error);
                    }
                    )
                )
            ),
            catchError(err => {
                const parsed = this.parseError(err);
                this.onHataListe.forEach(fn => fn({ self: this, hatalar: parsed }));
                return throwError(() => err);
            })
        ).subscribe({
            next: async (event: HttpEvent<any>) => {
                if (event.type === HttpEventType.UploadProgress) {
                    // Progress yüzdesi
                    if (event.total) {
                        // const progress = Math.round(100 * event.loaded / event.total);
                        // const res = new FikoYTRequestResponse<T>();
                        // res.progress = progress;
                        // this.cevap.update((_val: IstekSonuc<any>) => {
                        this.cevap.turu = IstekOlayTuru.IlerlemeIstek;
                        this.cevap.istekIlerleme = { tipi: "UPLOAD", toplam: event.total ?? 0, durum: event.loaded, yuzde: Math.round(100 * event.loaded / (event.total ?? 0)) };
                        // return _val;
                        // })
                        this.onIstekIlerlemeListe.forEach(fn => fn({ self: this, ilerleme: this.cevap.istekIlerleme }));
                    }
                }
                if (event.type === HttpEventType.DownloadProgress) {
                    // Progress yüzdesi
                    if (event.total) {
                        // const progress = Math.round(100 * event.loaded / event.total);
                        // const res = new FikoYTRequestResponse<T>();
                        // res.progress = progress;
                        // this.onCevapIlerlemeListe.forEach(fn => fn(this, res));
                        // this.cevap.update((_val: IstekSonuc<any>) => {
                        this.cevap.turu = IstekOlayTuru.IlerlemeCevap;
                        this.cevap.cevapIlerleme = { tipi: "UPLOAD", toplam: event.total ?? 0, durum: event.loaded, yuzde: Math.round(100 * event.loaded / (event.total ?? 0)) };
                        // return _val;
                        // })
                        this.onCevapIlerlemeListe.forEach(fn => fn({ self: this, ilerleme: this.cevap.cevapIlerleme }));
                    }
                } else if (event.type === HttpEventType.Sent) {

                    // this.cevap.update((_val: IstekSonuc<any>) => {
                    this.cevap.turu = IstekOlayTuru.Istendi;
                    this.cevap.cevapIlerleme = { tipi: "UPLOAD", toplam: 100, durum: 100, yuzde: 100 };
                    // return _val;
                    // })

                }
                else if (event.type === HttpEventType.Response) {
                    // this.cevap.update((_val: IstekSonuc<any>) => {
                    this.cevap.turu = IstekOlayTuru.Cevaplandi;
                    this.cevap.cevapIlerleme = { tipi: "DOWNLOAD", toplam: 100, durum: 100, yuzde: 100 };
                    this.cevap.istekIlerleme = { tipi: "UPLOAD", toplam: 100, durum: 100, yuzde: 100 };

                    //     return _val;
                    // })
                    // const response = new FikoYTRequestResponse<T>();
                    // response.result = event.body?.sonuc ?? event.body;
                    // response.type = 'NETWORK';
                    // response.endTime = new Date();
                    // delete response.progress;

                    // if (this.depoModu) {
                    //     FikoYTIstekKok.ramDeposu.set(cacheKey, response.result);
                    //     localStorage.setItem(
                    //         FikoYTIstekKok.lokalDepoIsmiOnEki + cacheKey,
                    //         JSON.stringify(response.result)
                    //     );
                    // }
                    // console.log(event.body);
                    /** */
                    if (event.body?.durum?.hata == true) {
                        const parsed = this.parseError(event.body?.durum?.hatalar);
                        // this.cevap.update((_val: IstekSonuc<any>) => {
                        this.cevap.turu = IstekOlayTuru.IptalEdildi;
                        this.cevap.cevapIlerleme = { tipi: "DOWNLOAD", toplam: 100, durum: 100, yuzde: 100 };
                        this.cevap.sonuc = event.body?.sonuc;
                        // _val.durum = { hata: true, hatalar: parsed };
                        this.cevap.durum!.hata = true;
                        this.cevap.durum!.hatalar = parsed;


                        //     return _val;
                        // })


                        this.onHataListe.forEach(fn => fn({ self: this, hatalar: parsed }));
                        throwError(() => parsed);
                    }

                    /** */

                    // this.cevap.update((_val: IstekSonuc<any>) => {
                    this.cevap.turu = IstekOlayTuru.Cevaplandi;
                    this.cevap.cevapIlerleme = { tipi: "DOWNLOAD", toplam: 100, durum: 100, yuzde: 100 };
                    // this.cevap.sonuc = event.body?.sonuc ?? event.body

                    // setTimeout(() => {
                        this.onMesgulDegistiListe.forEach(fn => fn({ self: this, mesgul: this.mesgul }));
                    // }, 0);
                    // return _val;
                    // })
                    let sonuc = event.body?.sonuc;
                    // console.log(sonuc, event.body?.sonuc?.sonuc, event.body);
                    await this.onOnceCevapListe.forEach(async fn => sonuc = await (fn({ self: this, sonuc: sonuc }))) ?? sonuc;
                    this.cevap.sonuc = sonuc
                    this.onCevapListe.forEach(fn => fn({ self: this, sonuc: sonuc }));

                    // setTimeout(() => {
                        this.onMesgulDegistiListe.forEach(fn => fn({ self: this, mesgul: this.mesgul }));
                    // }, 0);
                }
            },
            // error: (err) => {
            //     console.log("Hataaa", err);

            // },
            // error: (err) => { 

            // },
            complete: async () => {


                if (this.gecikmeliCevap) {
                    await new Promise(resolve => setTimeout(resolve, this.gecikmeliCevapSuresi));
                }
                // this.cevap.update((_val: IstekSonuc<any>) => {
                this.cevap.turu = IstekOlayTuru.Tamamlandi;
                this.cevap.durum!.mesgul = false;
                this.cevap.durum!.bitisZamani = new Date();

                //     return _val;
                // })

                // setTimeout(() => {
                    if (this.otoMesgul == true)
                        this.mesgul = false;
                    this.onMesgulDegistiListe.forEach(fn => fn({ self: this, mesgul: this.mesgul }));
                    // this.CD.detectChanges();
                // }, 0);
                this.onTamamlandiListe.forEach(fn => fn({ self: this }));
                onComplete();


            }
        });
    }

    private _calistirResolve?: (self: this) => void;

    /**
     * Kuyruğa ekler ve await ile sonucu bekler.
     * İstek tamamlandığında bu nesnenin kendisini döndürür.
     */
    async isteSync(): Promise<this> {
        return new Promise<this>(async (resolve) => {
            // this._calistirResolve = resolve;
            // FikoYTIstekKok.kuyruk.push(new FikoYTQueueItem(this, this.oncelik));
            // FikoYTIstekKok.kuyruk.sort((a, b) => b.oncelik - a.oncelik);
            // FikoYTIstekKok.tryProcessQueue();

            await this.execute(() => { resolve(this); });

        });
    }


    private parseError(err: HttpErrorResponse | FikoHatalar | FikoHata | any): FikoHatalar {
        const errors: FikoHatalar = [];
        const data = err;


        if (Array.isArray(err)) {
            for (const item of data) {
                errors.push({ ...item, baslik: item.baslik ?? 'Hata', mesaj: item.mesaj ?? 'Bir hata oluştu' });
            }
        } else if (typeof data === 'object' && data !== null) {
            errors.push({ ...data, baslik: data.baslik ?? 'Hata', mesaj: data.mesaj ?? 'Bir hata oluştu' });
        } else {
            errors.push({ baslik: 'Bilinmeyen Hata', mesaj: err.message ?? 'Bir hata oluştu' });
        }

        return errors;
    }
}